import styled from 'styled-components';
import { animated } from 'react-spring';
import {
  Container as RawContainer,
  size,
  colors,
  typography,
  mediaQueries,
  InfoBlock as BaseInfoBlock,
} from '@everlywell/leaves';

import SectionTitle from '../SectionTitle';
import SectionHeadine from './SectionHeadline';

export const Container = styled(RawContainer)`
  padding-top: ${size.xl4}px;

  ${mediaQueries.forTabletHorizontalUp} {
    padding-top: ${size.xl6}px;
  }
`;

export const Title = styled(SectionTitle)`
  text-align: left;
  ${mediaQueries.forTabletHorizontalUp} {
    text-align: unset;
  }
`;

export const Headline = styled(SectionHeadine)`
  text-align: left;
  margin-bottom: ${size.xl1}px;
  ${mediaQueries.forTabletHorizontalUp} {
    text-align: unset;
    margin-bottom: ${size.xl6}px;
  }
`;

export const InfoBlockContainer = styled.div`
  ${mediaQueries.forTabletHorizontalUp} {
    flex-direction: row-reverse;
    margin-bottom: ${size.xl6}px;
  }
`;

export const InfoBlock = styled(BaseInfoBlock).attrs(props => ({
  imageAlt: props.imageAlt
}))`
  max-width: 33.188rem;
  margin-bottom: ${size.xl1}px;

  p {
    line-height: 1.75;
    color: ${colors.gray4};
    font-weight: ${typography.weight.book};
    letter-spacing: 0;
  }

  ${mediaQueries.forTabletHorizontalUp} {
    flex: 1 1 50%;
    margin-bottom: ${size.xl4}px;
  }
`;

export const MainImageContainer = styled.div`
  margin-top: ${size.xl1}px;
  z-index: -1;
  ${mediaQueries.forTabletHorizontalUp} {
    display: none;
  }
`;

export const MainImageContent = styled.div`
  position: relative;
  margin: 0 auto;
  max-width: 327px;
  min-height: 307px;
  overflow: hidden;
`;

export const MobileAnimatedImage = styled(animated.img)`
  position: absolute;
`;

export const DesktopImageContainer = styled.div`
  position: relative;
  display: none;
  ${mediaQueries.forTabletHorizontalUp} {
    display: block;
  }
`;
export const TopImage = styled(animated.img)`
  max-width: 253px;
  position: absolute;
  top: -3.5rem;
`;

export const BottomImage = styled(animated.img)`
  max-width: 253px;
  position: absolute;
  bottom: -3.5rem;
  right: 0;
`;
export const MiddleImage = styled.img`
  max-width: 530px;
`;
